export default __webpack_public_path__ + "static/media/all_w320.686d15e4.jpeg";